import React from 'react';

type Preset = '7d' | '30d' | 'month_current' | 'month_previous' | 'year_current' | 'custom';

interface Props {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
}

const computePreset = (preset: Preset): { from: string; to: string } => {
  const today = new Date();
  const fmt = (d: Date) => d.toISOString().slice(0, 10);
  switch (preset) {
    case '7d': {
      const from = new Date(today);
      from.setDate(today.getDate() - 7);
      return { from: fmt(from), to: fmt(today) };
    }
    case '30d': {
      const from = new Date(today);
      from.setDate(today.getDate() - 30);
      return { from: fmt(from), to: fmt(today) };
    }
    case 'month_current': {
      const from = new Date(today.getFullYear(), today.getMonth(), 1);
      return { from: fmt(from), to: fmt(today) };
    }
    case 'month_previous': {
      const from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const to = new Date(today.getFullYear(), today.getMonth(), 0);
      return { from: fmt(from), to: fmt(to) };
    }
    case 'year_current': {
      const from = new Date(today.getFullYear(), 0, 1);
      return { from: fmt(from), to: fmt(today) };
    }
    default:
      return { from: fmt(today), to: fmt(today) };
  }
};

export const DateRangePicker: React.FC<Props> = ({ from, to, onChange }) => {
  const handlePreset = (preset: Preset) => {
    const { from: f, to: t } = computePreset(preset);
    onChange(f, t);
  };

  return (
    <div className="flex items-center gap-2">
      <input
        type="date"
        value={from}
        onChange={(e) => onChange(e.target.value, to)}
        className="border border-gray-300 rounded px-2 py-1 text-sm"
      />
      <span className="text-gray-500">→</span>
      <input
        type="date"
        value={to}
        onChange={(e) => onChange(from, e.target.value)}
        className="border border-gray-300 rounded px-2 py-1 text-sm"
      />
      <select
        onChange={(e) => handlePreset(e.target.value as Preset)}
        className="border border-gray-300 rounded px-2 py-1 text-sm"
        defaultValue=""
      >
        <option value="" disabled>Préréglages</option>
        <option value="7d">7 derniers jours</option>
        <option value="30d">30 derniers jours</option>
        <option value="month_current">Mois courant</option>
        <option value="month_previous">Mois précédent</option>
        <option value="year_current">Année courante</option>
      </select>
    </div>
  );
};

export default DateRangePicker;
